import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconBell(rest) {
  return (
    <Icon viewBox="0 0 17 18" {...rest}>
      <path
        fill="currentColor"
        d="M8,18 C9.1,18 10,17.1 10,16 L6,16 C6,17.1 6.89,18 8,18 Z M14,12 L14,8.99993896 C14,5.92993896 12.36,3.35993896 9.5,2.67993896 L9.5,1.99993896 C9.5,1.16993896 8.83,0.499938965 8,0.499938965 C7.17,0.499938965 6.5,1.16993896 6.5,1.99993896 L6.5,2.67993896 C3.63,3.35993896 2,5.91993896 2,8.99993896 L2,12 L0,14 L0,15 L16,15 L16,14 L14,12 Z"
      />
    </Icon>
  )
}
